module.exports = __webpack_public_path__ + "static/media/talk04_small@3x.e6bf643c.jpg";